var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.0025 39.5996C29.0279 39.5996 30.67 37.9578 30.67 35.9321C30.67 33.9067 29.0279 32.2646 27.0025 32.2646C24.977 32.2646 23.335 33.9067 23.335 35.9321C23.335 37.9578 24.977 39.5996 27.0025 39.5996Z",
    fill: "#C5950B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.13 22.005V19.1925C41.13 13.1175 39.6675 5.0625 27 5.0625C14.3325 5.0625 12.87 13.1175 12.87 19.1925V22.005C6.57 22.7925 4.5 25.9875 4.5 33.84V38.025C4.5 47.25 7.3125 50.0625 16.5375 50.0625H37.4625C46.6875 50.0625 49.5 47.25 49.5 38.025V33.84C49.5 25.9875 47.43 22.7925 41.13 22.005ZM27 42.7275C23.2425 42.7275 20.205 39.6675 20.205 35.9325C20.205 32.175 23.265 29.1375 27 29.1375C30.735 29.1375 33.795 32.1975 33.795 35.9325C33.795 39.69 30.7575 42.7275 27 42.7275ZM16.5375 21.8025C16.3575 21.8025 16.2 21.8025 16.02 21.8025V19.1925C16.02 12.6 17.8875 8.2125 27 8.2125C36.1125 8.2125 37.98 12.6 37.98 19.1925V21.825C37.8 21.825 37.6425 21.825 37.4625 21.825H16.5375V21.8025Z",
    fill: "#C5950B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d99e6ec533caf9280d41d388cb046b2c.svg";
export { ForwardRef as ReactComponent };